import { Skeleton } from '@mint-lib/tw-components';

const SidebarSkeleton = () => {
  return (
    <div
      data-testid="sidebar-skeleton"
      className="flex w-full flex-col gap-2 p-2"
    >
      <Skeleton className="h-7" />
      <Skeleton className="ml-2 h-5" />
      <Skeleton className="ml-4 h-5" />
      <Skeleton className="ml-4 h-5" />
      <Skeleton className="ml-4 h-5" />
      <Skeleton className="ml-4 h-5" />
      <Skeleton className="ml-4 h-5" />
      <Skeleton className="ml-4 h-5" />
      <Skeleton className="ml-4 h-5" />
      <Skeleton className="ml-4 h-5" />
      <Skeleton className="ml-4 h-5" />
      <Skeleton className="ml-4 h-5" />
    </div>
  );
};

export default SidebarSkeleton;
